export type ExplorerPlateSelection = {
  experimentId: number | null;
  plateIds: number[];
};

const emptySelection: ExplorerPlateSelection = {
  experimentId: null,
  plateIds: [],
};

let currentSelection: ExplorerPlateSelection = emptySelection;

export function setExplorerPlateSelection(selection: ExplorerPlateSelection) {
  currentSelection = {
    experimentId: selection.experimentId == null ? null : Number(selection.experimentId),
    plateIds: (selection.plateIds ?? []).map((plateId) => Number(plateId)),
  };
}

export function getExplorerPlateSelection(): ExplorerPlateSelection {
  return currentSelection;
}

export function getScopedPlateIds(experimentId: number): number[] | null {
  if (
    experimentId == null ||
    currentSelection.experimentId !== Number(experimentId) ||
    currentSelection.plateIds.length === 0
  ) {
    return null;
  }
  return currentSelection.plateIds;
}
